<script lang="ts">
    import ReviewsAverageRatingStars from "@apps/reviews/components/ReviewsAverageRatingStars/ReviewsAverageRatingStars.svelte";
    import { REVIEWS_BRANDING_PRODUCT_AVG_RATING_DISPLAY_STYLE } from "@apps/reviews/constants";
    import { GwI18n } from "@modules/i18n/GwI18n/GwI18n";

    import T from "@components/T.svelte";

    export let averageReviewsRating: number;
    export let reviewsCount: number;
    export let displayStyle: REVIEWS_BRANDING_PRODUCT_AVG_RATING_DISPLAY_STYLE;
    export let gwI18n: GwI18n;

    const product_no_reviews_yet$ = gwI18n.selectT(
        "reviews.AverageReviewsWidget",
        "product_no_reviews_yet"
    );
</script>

<ReviewsAverageRatingStars
    rating={averageReviewsRating}
    iconTitle={$product_no_reviews_yet$}
/>
{#if displayStyle !== REVIEWS_BRANDING_PRODUCT_AVG_RATING_DISPLAY_STYLE.SHOW_STARS_ONLY}
    <span class="gw-rv-average__rating_text">
        {#if reviewsCount === 1}
            1 <T
                namespace="reviews.AverageReviewsWidget"
                translationKey="review"
            />
        {:else if reviewsCount === 0}
            <T
                namespace="reviews.AverageReviewsWidget"
                translationKey="no_reviews"
            />
        {:else}
            <T
                namespace="reviews.AverageReviewsWidget"
                translationKey="reviews"
                translationOptions={{
                    count: reviewsCount,
                }}
            />
        {/if}
    </span>
{/if}

<style>
    .gw-rv-average__rating_text {
        font-size: 0.875em;
        line-height: 1.2em;
        white-space: nowrap;
    }
</style>
